import { createFileRoute } from '@tanstack/react-router'
import { VisitorDetailsOverviewPage } from 'features/visitorDetails'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/')({
  component: VisitorDetailsOverviewPage,
})
